import Routines from "./routines";

export default [
  // Each object is a day
  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week4day1,
    title: "Basic Core Strength IV-A",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week4day2,
    title: "Basic Core Strength IV-B",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week4day1,
    title: "Basic Core Strength IV-A",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week4day2,
    title: "Basic Core Strength IV-B",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week4day1,
    title: "Basic Core Strength IV-A",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week4day2,
    title: "Basic Core Strength IV-B",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week4day1,
    title: "Basic Core Strength IV-A",
  },
];
